export default function formatNumber(
  num: number | undefined,
  precision = 2,
  locale = "en",
) {
  if (!num) {
    return;
  }

  const map = [
    { suffix: "trln", threshold: 1e12 },
    { suffix: "bln", threshold: 1e9 },
    { suffix: locale === "en" ? "mln" : "juta", threshold: 1e6 },
    { suffix: "k", threshold: 1e3 },
    { suffix: "", threshold: 1 },
  ];

  const found = map.find((x) => Math.abs(num) >= x.threshold);

  if (found) {
    return (num / found.threshold).toFixed(precision) + found.suffix;
  }

  return num;
}
